import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import loginReducer from './slices/loginSlice'
import languageReducer from './slices/languageSlice'
import medicalReducer from './slices/medicalSlice'
import preAuthReducer from './slices/preAuthSlice'
import insuranceReducer from './slices/insuranceSlice'
import applicationsReducer from './slices/applicationsSlice'
import recentActivitiesReducer from './slices/recentActivitiesSlice'
import requiredActionsReducer from './slices/requiredActionsSlice'
import portalMessagesReducer from './slices/portalMessagesSlice'
import lookupReducer from './slices/lookupSlice'
import appViewDetailsReducer from './slices/appViewDetailsSlice'
import preQualFundsListReducer from './slices/preQual/preQualFundsListSlice'
import preQualQuestionsReducer from './slices/preQual/preQualQuestionsSlice'
import appvalidationReducer from './slices/appvalidationsSlice'
import einReducer from './slices/einSlice'
import browserIDVerifyReducer from './slices/browserIDVerifySlice'
import registerReducer from './slices/registerSlice'
import updatePasswordReducer from './slices/updatePasswordSlice'
import smartyStreetReducer from './slices/smartyStreetSlice'
import generalConfigReducer from './slices/generalConfiguration/generalConfigSlice'
import patientSearchReducer from './slices/patientSearch/patientSearchSlice'
import preQualValidateReducer from './slices/preQual/preQualValidateSlice'
import fundSpecificLookupReducer from './slices/preQual/fundSpecificLookupSlice'
import routeRestrictionReducer from './slices/generalConfiguration/routeRestrictionSlice'
import updatePatientReducer from './slices/appIntake/updatePatientSlice'
import applicationSubmissionReducer from './slices/appIntake/applicationSubmissionSlice'
import searchProviderReducer from './slices/appIntake/searchProviderSlice'
import validateSessionReducer from './slices/validateSession/validateSessionSlice'
import patientApplicationListReducer from './slices/patientSearch/patientApplicationListSlice'
import portalUserEmailUpdateReducer from './slices/portalUserEmailUpdate/portalUserEmailUpdateSlice'
import extendSessionReducer from './slices/generalConfiguration/sessionExtendSlice'
import logOutReducer from './slices/generalConfiguration/logOutSlice'
import financialResourceDirectoryReducer from './slices/financialResourceDirectorySlice'
import documentListReducer from './slices/document/documentListSlice'
import documentDownloadReducer from './slices/document/documentDownloadSlice'
import regenerateDocumentReducer from './slices/document/regenerateDocumentSlice'
import claimListReducer from './slices/claimIntake/claimListSlice'
import claimProcessReducer from './slices/claimIntake/claimProcessSlice'
import claimSubmissionReducer from './slices/claimIntake/claimSubmissionSlice'
import uploadDocumentReducer from './slices/document/uploadDocumentSlice'
import claimIntakeReducer from './slices/claimIntake/claimIntakeSlice'
import claimDetailReducer from './slices/claimDetailSlice'
import emailSendReducer from './slices/emailSendSlice'
import educationResourceDirectoryReducer from './slices/educationResourceDirectorySlice'
import allServiceReducer from './slices/supertokens/allSessionsSlice'
import jwtTokenReducer from './slices/supertokens/jwtTokenSlice'
import metaDataReducer from './slices/supertokens/metaDataSlice'
import passwordlessSignUpReducer from './slices/supertokens/passwordlessSignUpSlice'
import passworlessUpdateReducer from './slices/supertokens/passwordlessUpdateSlice'
import portalUserReducer from './slices/supertokens/portalUserSlice'
import revokeSessionReducer from './slices/supertokens/revokeSessionSlice'
import settingSecondFactorIdReducer from './slices/supertokens/secondFactorIdSlice'
import sentMailReducer from './slices/supertokens/sentMailSlice'
import supertokenRevokeReducer from './slices/supertokens/supertokenRevokeSlice'
import verifyEmailReducer from './slices/supertokens/verifyEmailSlice'
import sessionReducer from './slices/supertokens/sessionSlice'
import memberDataReducer from './slices/supertokens/memberDataSlice'
import getTokenReducer from './slices/getTokenSlice'
import oAuthCMReducer from './slices/caseManagement/oAuthCMSlice'
import caseListReducer from './slices/caseManagement/caseListSlice'
import patientCaseListReducer from './slices/caseManagement/patientCaseListSlice'
import generateHashDataReducer from './slices/caseManagement/generateHashDataSlice'
import caseReportsReducer from './slices/caseManagement/caseReportsSlice'
import filterFundReducer from './slices/filterFundSlice'
import formularyDetailsReducer from './slices/appIntake/formularyDetailsSlice'

export const store = configureStore({
  reducer: {
    loginSlice: loginReducer,
    languages: languageReducer,
    medicalSlice: medicalReducer,
    preAuthSlice: preAuthReducer,
    insuranceSlice: insuranceReducer,
    applicationsSlice: applicationsReducer,
    recentActivitiesSlice: recentActivitiesReducer,
    requiredActionsSlice: requiredActionsReducer,
    portalMessagesSlice: portalMessagesReducer,
    lookupSlice: lookupReducer,
    preQualFundsListSlice: preQualFundsListReducer,
    preQualQuestionsSlice: preQualQuestionsReducer,
    appvalidationsSlice: appvalidationReducer,
    einSlice: einReducer,
    registerSlice: registerReducer,
    browserIDVerifySlice: browserIDVerifyReducer,
    updatePasswordSlice: updatePasswordReducer,
    smartyStreetSlice: smartyStreetReducer,
    generalConfigSlice: generalConfigReducer,
    patientSearchSlice: patientSearchReducer,
    preQualValidateSlice: preQualValidateReducer,
    fundSpecificLookupSlice: fundSpecificLookupReducer,
    routeRestrictionSlice: routeRestrictionReducer,
    updatePatientSlice: updatePatientReducer,
    applicationSubmissionSlice: applicationSubmissionReducer,
    searchProviderSlice: searchProviderReducer,
    validateSessionSlice: validateSessionReducer,
    patientApplicationListSlice: patientApplicationListReducer,
    portalUserEmailUpdateSlice: portalUserEmailUpdateReducer,
    extendSessionSlice: extendSessionReducer,
    logOutSlice: logOutReducer,
    financialResourceDirectorySlice: financialResourceDirectoryReducer,
    appViewDetailsSlice: appViewDetailsReducer,
    documentListSlice: documentListReducer,
    documentDownloadSlice: documentDownloadReducer,
    regenerateDocumentSlice: regenerateDocumentReducer,
    claimListSlice: claimListReducer,
    claimProcessSlice: claimProcessReducer,
    claimSubmissionSlice: claimSubmissionReducer,
    uploadDocumentSlice: uploadDocumentReducer,
    claimIntakeSlice: claimIntakeReducer,
    claimDetailSlice: claimDetailReducer,
    emailSendSlice: emailSendReducer,
    educationResourceDirectorySlice:educationResourceDirectoryReducer,
    allServiceSlice:allServiceReducer,
    jwtTokenSlice:jwtTokenReducer,
    metaDataSlice:metaDataReducer,
    passwordlessSignUpSlice:passwordlessSignUpReducer,
    passworlessUpdateSlice:passworlessUpdateReducer,
    portalUserSlice:portalUserReducer,
    revokeSessionSlice:revokeSessionReducer,
    settingSecondFactorIdSlice:settingSecondFactorIdReducer,
    sentMailSlice:sentMailReducer,
    supertokenRevokeSlice:supertokenRevokeReducer,
    updatePasswordSlice:updatePasswordReducer,
    verifyEmailSlice:verifyEmailReducer,
    sessionSlice:sessionReducer,
    memberDataSlice:memberDataReducer,
    getTokenSlice:getTokenReducer,
    oAuthCMSlice:oAuthCMReducer,
    patientCaseListSlice:patientCaseListReducer,
    caseListSlice:caseListReducer,
    generateHashDataSlice:generateHashDataReducer,
    caseReportsSlice:caseReportsReducer,
    filterFundSlice:filterFundReducer,
    formularyDetailsSlice:formularyDetailsReducer,
  },
  middleware:
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})
